export const BASE_URL = 'https://api.tenrai.org/v1'